const mobile_nav = () => {

    var scrollDistance = 0;
    var prevScroll = 0;

    jQuery('.mobile-menu--open').on('click', function(){
        // Get the scroll distance at the time the modal was opened
        var menuHeight = 0;

        scrollDistance = $(window).scrollTop()
        
        jQuery('body').toggleClass('mobile-menu-open')

        if($("body").hasClass('mobile-menu-open')) {
            prevScroll = scrollDistance;
            console.log('open', scrollDistance)

            // Pull the top of the body up by that amount
            $("body").css("top", scrollDistance * -1)

            menuHeight = $(window).height() - $('.mobile-menu--top').outerHeight();
        }

        if(!$("body").hasClass('mobile-menu-open')) {
            console.log('closed', prevScroll)
            $("body").css("top", "")
            $(window).scrollTop(prevScroll)
        } 

        jQuery(this).toggleClass('mobile-menu--close')
        jQuery('.mobile-menu--main')
            .css({maxHeight: menuHeight + 'px'})
            .slideToggle()
        jQuery('.mobile-menu--sub-menu').slideUp()
        jQuery('.mobile-menu--icon').removeClass('mobile-menu--icon-active')
        jQuery('.mobile-menu--icon-open, .mobile-menu--icon-close').toggleClass('d-none')
    })

    jQuery('.mobile-menu--item .mobile-menu--icon').on('click', function() {
        jQuery(this).parent().parent('.mobile-menu--item').children('.mobile-menu--sub-menu').slideToggle()
        jQuery(this).toggleClass('mobile-menu--icon-active')
        // jQuery('body').removeClass('mobile-menu-open');
    })
}

export default mobile_nav;